var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"delete-category-modal","title":"Delete Confirmation","okTitle":"Delete","okVariant":"danger"},on:{"ok":_vm.deleteRecord}},[(_vm.category)?_c('p',{staticClass:"py-0"},[_vm._v(" Are you sure you want to delete the record \""+_vm._s(_vm.category.name)+"\"? This action can't be undone. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }